import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import axios from 'axios'

axios.get('app/analytics.txt').then((res) => {
  Vue.use(VueAnalytics, {
    id: res.data
  })
});


